import Answer from './Answer'

function Answers({answerOptions, setAnswerOptions, readOnly}) {
  const AddAnswer = ()=>{
    const oId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
    s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h))
    setAnswerOptions([...answerOptions,  {_id:oId()}])
  }
  
  const RemoveAnswer = (id) =>{
    const answers = answerOptions.filter(answer=>answer._id !==id)
    setAnswerOptions(answers)
  }
  const UpdateAnswer = ({_id, img, answerBody, isCorrectAnswer}) =>{
    const answers = answerOptions.map(answer=> (answer._id !==_id)?answer: {_id, img, answerBody, isCorrectAnswer} )
    setAnswerOptions(answers)
  }
  return (
  <div className='answer-pane'>
  {!readOnly && <button className="bg-white p-2 rounded" type='button' onClick={AddAnswer}>Add Answer</button>}
    {answerOptions.map(answer=><Answer key={answer._id} readOnly={readOnly} answer={answer} RemoveAnswer={RemoveAnswer} UpdateAnswer={UpdateAnswer}  /> )}
    </div>)
}

export default Answers